"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
function Footer() {
    return (react_1.default.createElement("footer", { id: "footer" },
        react_1.default.createElement("div", { className: "inner" },
            react_1.default.createElement("ul", { className: "icons" },
                react_1.default.createElement("li", null,
                    react_1.default.createElement("a", { href: "https://github.com/carolinemarcks" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: ['fab', 'github'] }))),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("a", { href: "https://www.linkedin.com/in/carolinemarcks" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: ['fab', 'linkedin'] }))),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("a", { href: "mailto:caroline.marcks@gmail.com" },
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "envelope" })))),
            react_1.default.createElement("ul", { className: "copyright" },
                react_1.default.createElement("li", null, "\u00A9 Caroline Marcks 2019"),
                react_1.default.createElement("li", null,
                    "Design: ",
                    react_1.default.createElement("a", { href: "http://html5up.net" }, "HTML5 UP"))))));
}
exports.default = Footer;
